<template>
  <div class='CardIndicador'>
    <div class='label'>
      {{ label }}
      <span class='ajuda'>?</span>
    </div>
    <div class='valor'>{{ valor }}</div>
    <div class='porcentagem' :class='tendencia'>
      {{ porcentagemFormatada }}%
      <span v-if="tendencia === 'neutra'" class='ponto'></span>
      <span v-else class='seta'></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardIndicador',
  props: {
    label: { type: String, required: true },
    valor: { type: [String, Number], required: true },
    porcentagem: { type: Number, default: 0 }
  },
  computed: {
    tendencia () {
      if (this.porcentagem > 0) return 'alta'
      if (this.porcentagem < 0) return 'queda'
      return 'neutra'
    },
    porcentagemFormatada () {
      return Math.abs(this.porcentagem).toLocaleString('pt-BR', { maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.CardIndicador {
  flex: 1;
  padding: 16px 24px;
  border-right: 1px solid #e5e5e5;
}
.CardIndicador:last-child {
  border-right: none;
}
.label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #303030;
}
.ajuda {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #b5b5b5;
  color: #fff;
  font-size: 9px;
  font-weight: bold;
}
.valor {
  margin-top: 4px;
  font-size: 18px;
  color: #303030;
}
.porcentagem {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 13px;
}
.alta { color: #1a8f4c; }
.queda { color: #d72c46; }
.neutra { color: #e0712c; }
.seta {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
}
.queda .seta { border-top: 7px solid currentColor; }
.alta .seta { border-bottom: 7px solid currentColor; }
.ponto {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: currentColor;
}
</style>
